import { UserManagementApi } from '../../api-client/generated/api';
import { getMediaRate } from '../../utils/general';

const apiCaller = new UserManagementApi();

const createFakeResources = (mediaRate?: string, cantResources: number = 1) => {
  const resources = Array.from({ length: cantResources }, (_, index) => {
    return {
      hrAvailable: 40,
      id: index,
      name: `Resource ${index + 1}`,
      profilePic: null,
      rate: mediaRate,
      status: 'AVAILABLE'
    };
  });

  return resources;
};

const getSkillResource = async (params: any) => {
  const response = await apiCaller.usersUserRources({
    skillResourceDTO: {
      skills: params.skillIds
    }
  });

  if (Array.isArray(response.data)) {
    const { data } = response;
    const mappedData = data.map((user: any) => ({
      hrAvailable:
        (user?.availabilityData?.availableHoursPerWeek || 40) -
        (user?.availabilityData?.scheduledHoursPerWeek || 0),
      id: user.id,
      name: `${user.firstName} ${user.lastName}`,
      profilePic: user.profilePic ? user.profilePic : null,
      rate: user.rate || 'not rate',
      rateNumber: Number(user.rate || 0),
      status: user.availability,
      timeFormat: user?.timeFormat
    }));
    const mediaRate = getMediaRate(mappedData);

    return mappedData.map((resource) => {
      return { ...resource, mediaRate };
    });
  }

  return [];
};

const getSupervisor = async (params: any) => {
  const response = await apiCaller.usersUserRources({
    skillResourceDTO: {
      skills: [params]
    }
  });

  if (Array.isArray(response.data)) {
    const { data } = response;
    const mappedData = data.map((user: any) => ({
      hrAvailable:
        (user?.availabilityData?.availableHoursPerWeek || 40) -
        (user?.availabilityData?.scheduledHoursPerWeek || 0),
      id: user.id,
      name: `${user.firstName} ${user.lastName}`,
      profilePic: user.profilePic ? user.profilePic : null,
      rate: user.rate || 'not rate',
      status: user.availability,
      timeFormat: user?.timeFormat
    }));
    return mappedData;
  }

  return [];
};

const getUsersByRole = async (params: any) => {
  const { roles } = params;
  const response = await apiCaller.usersFindUsersByRole({ rolesArray: roles });
  return response.data;
};

export default {
  createFakeResources,
  getSkillResource,
  getSupervisor,
  getUsersByRole
};
